export default __webpack_public_path__ + "static/media/batt.759e9611.svg";